import React from 'react'
import { FiCheckCircle, FiFileText, FiDownload } from 'react-icons/fi'
import LogoClicksign from '@resources/imgs/logo-empresa.png'
import { formatOrderDate } from '../../utils/formatOrderDate'
import './ContractStatus.css'

interface SignedContractStatusProps {
  signed_at?: Date | null
  document_url?: string | null
  has_patient_signed: boolean
  signed_count: number
  total_signers: number
  are_all_signed: boolean
  signing_url?: string | null
}

const SignedContractStatus: React.FC<SignedContractStatusProps> = ({
  signed_at,
  document_url,
  has_patient_signed,
  signed_count,
  total_signers,
  are_all_signed,
  signing_url
}) => {
  return (
    <div className="contract-status-container-signed">
      {/* Header Section */}
      <div className="contract-header-section">
        <div className="d-flex align-items-center gap-3">
          <div className="clicksign-logo-header">
            <img src={LogoClicksign} alt="Clicksign" />
          </div>
        </div>
        <div className="status-badge-completed">
          <FiCheckCircle size={16} />
          Concluído
        </div>
      </div>

      {/* Content Section */}
      <div className="contract-content-section">
        {are_all_signed ? (
          <>
            {/* Success Message Box */}
            <div className="contract-success-box">
              <div className="success-icon-box">
                <FiCheckCircle size={32} />
              </div>
              <div>
                <h5 className="success-title mb-1">Contrato Assinado!</h5>
                <p className="success-date mb-0">{formatOrderDate(signed_at ?? undefined)}</p>
              </div>
            </div>

            {/* Info Message */}
            <div className="contract-info-message">
              <p className="mb-0">
                Documento válido juridicamente. Prossiga com as próximas etapas do seu pedido.
              </p>
            </div>

            {/* Download Button */}
            {document_url && (
              <a
                href={document_url}
                target="_blank"
                rel="noopener noreferrer"
                className="contract-download-button"
              >
                <FiDownload size={22} />
                Baixar Contrato Assinado
              </a>
            )}
          </>
        ) : (
          <>
            {has_patient_signed ? (
              <>
                {/* Signed Confirmation Box */}
                <div className="signed-confirmation-box">
                  <FiCheckCircle className="text-success" size={24} />
                  <div>
                    <p className="mb-2"><strong>Você já assinou o contrato!</strong></p>
                    <p className="text-muted mb-2">
                      Assinaturas concluídas: <strong>{signed_count} de {total_signers}</strong>
                    </p>
                    <p className="text-muted mb-0">
                      Aguardando as demais assinaturas para finalizar o contrato.<br />
                      Quando todos assinarem, você poderá baixa-lo.
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Warning for pending signature */}
                <div className="contract-warning-alert">
                  <div className="warning-icon-box">
                    <FiFileText size={24} />
                  </div>
                  <p className="warning-text mb-0">
                    Outras partes já assinaram (<strong>{signed_count} de {total_signers}</strong>).
                    Sua assinatura ainda é necessária para finalizar o contrato.
                  </p>
                </div>

                {/* Sign Button */}
                {signing_url && (
                  <a
                    href={signing_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contract-sign-button"
                  >
                    <FiFileText size={22} />
                    Assinar Contrato Agora
                  </a>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default SignedContractStatus
